import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import patchNotifications from 'Api/notification/patchNotifications';

import patchNotificationRequest from './model/request/patchNotificationRequest';

const usePatchNotification = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ notification, selectedTab }) => {
      if (selectedTab === 'unread') {
        const payload = patchNotificationRequest(notification);
        await patchNotifications(payload);
      }

      return notification;
    },
    onSuccess: (notification) => {
      queryClient.invalidateQueries({ queryKey: ['notification'] });
      const path = notification.targetUrl ?? '/forbidden-schedule';

      navigate(path);
    },
  });
};

export default usePatchNotification;
